import { useState } from "react";
import { Button } from "@/components/ui/button";
import { ShieldCheck, ShieldAlert } from "lucide-react";
import { api } from "@/lib/api";

export function PaystackAccountCheck() {
  const [r, setR] = useState(null);
  const [busy, setBusy] = useState(false);

  const check = async () => {
    setBusy(true);
    try { const { data } = await api.get("/payments/paystack-account"); setR(data); }
    catch { setR({ active: false, error: "Check failed — are you logged in as admin?" }); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-3 text-xs" data-testid="paystack-account-check">
      <Button size="sm" variant="ghost" disabled={busy} onClick={check} data-testid="paystack-account-check-btn" className="h-7 px-2 rounded-full text-neutral-300 hover:text-white hover:bg-white/5">
        {busy ? "Asking Paystack…" : "Check Paystack account"}
      </Button>
      {r && (
        <div className={`mt-2 rounded-md border p-2.5 ${r.active ? "border-[#34C759]/30 bg-[#34C759]/5" : "border-[#FF3B30]/30 bg-[#FF3B30]/5"}`} data-testid="paystack-account-result">
          <div className="flex items-center gap-1.5 font-bold">
            {r.active ? <ShieldCheck className="h-3.5 w-3.5 text-[#34C759]" /> : <ShieldAlert className="h-3.5 w-3.5 text-[#FF3B30]" />}
            {r.active ? `${r.mode.toUpperCase()} key accepted — account can receive payments` : (r.error || "Key not accepted")}
          </div>
          {r.active && (
            <div className="mt-1 text-neutral-400">
              Balance: {r.balances.length ? r.balances.map((b) => `${b.currency} ${b.amount.toLocaleString()}`).join(" · ") : "—"}
              {r.last_settlement ? ` · Last payout to bank: ${r.last_settlement.currency} ${r.last_settlement.amount.toLocaleString()} (${r.last_settlement.status})` : " · No bank payout yet"}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
